<template>
	<app-section class="flex flex-col" :class="$attrs.class">
		<div class="flex items-center">
			<app-title title="Comments" class="small flex flex-1" />
		</div>
		<div class="flex flex-row">
			<app-input
				class="flex flex-1"
				name="Comment"
				placeholder="Comment"
				v-model="newComment.comment"
				:hide-label="true"
			/>
			<app-select
				class="flex flex-1"
				:options="reasons"
				v-model="newComment.reasonid"
				placeholder="Reason"
				:hide-label="true"
			/>
			<app-button class="btn btn-success small my-3" @click="addComment" icon="save" />
		</div>
		<app-line />
		<div v-if="comments">
			<div class="flex relative pb-1" v-for="(comment, index) in comments" :key="index">
				<div class="w-4 h-4 rounded-full bg-primary z-50" />
				<div
					v-if="index !== comments.length - 1"
					class="border-l-2 absolute left-0 h-full border-border-color"
					style="left: 7px;"
				/>
				<div class="flex flex-1 flex-col text-13 ml-2">
					<p class="flex">
						<span v-if="comment.name && comment['surname']"
							>{{ comment.name[0] }}.{{ comment['surname'][0] }}</span
						>
						<span class="text-secondary">
							({{ ['Public', $filters.reasonFilter(comment['reasonid'])].join(' - ') }})
						</span>
					</p>
					<p class="flex">{{ comment.comment }}</p>
				</div>
				<div class="text-13">{{ $filters.fromNow(comment['registrationtime']) }}</div>
			</div>
		</div>
		<span v-else class="text-secondary m-auto">No Comments yet</span>
	</app-section>
</template>

<script>
	import OrderService from '@/services/OrderService';
	import reasons from '@/constants/reasonsComment';
	import { mapGetters } from 'vuex';

	const newCommentDefaultValue = {
		reasonid: null,
		comment: '',
	};

	export default {
		name: 'OrderComments',
		props: {
			orderId: {
				required: true,
				type: Number,
			},
		},
		computed: {
			...mapGetters({
				user: 'user',
			}),
		},
		data: () => ({
			loading: true,
			newComment: { ...newCommentDefaultValue },
			comments: [],
			reasons,
		}),
		methods: {
			getComments() {
				this.loading = true;
				OrderService.comments(this.orderId)
					.then((comments) => {
						this.comments = comments;
					})
					.catch((error) => {
						this.$notificationService.error(error);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			addComment() {
				const data = {
					orderid: this.orderId,
					namecomment: this.user.email,
					phone: this.user.phone,
					status: 1,
					done: 0,
					name: this.user.name,
					surname: this.user.surname,
					...this.newComment,
				};
				OrderService.addComment(this.orderId, data)
					.then(() => {
						this.newComment = { ...newCommentDefaultValue };
						this.getComments();
					})
					.catch((error) => {
						this.$notificationService.error(error);
					});
			},
		},
		mounted() {
			if (this.orderId) {
				this.getComments();
			}
		},
		watch: {
			orderId(value) {
				if (value) {
					this.getComments();
				}
			},
		},
	};
</script>
